var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bg-style',{staticClass:"store-widget-v2__two-column-list grid grid-cols-2 gap-4"},_vm._l((_vm.list),function(item,index){return _c('two-column-item',{key:index,attrs:{"site":_vm.site,"editing":_vm.editing,"good":item,"model":_vm.model},on:{"click":_vm.handleShowDetail,"submit":_vm.onSubmit}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }